<template>
    <div class="d-flex">
        <component 
            class="parallel portrait" 
            :announcement="this.announcements[0]"
            :refreshPeriod="this.refreshPeriod"
            :isLandscape="false"
            :isParallel="true"
            :is="returnComponent(0)"
            :isPreview="isPreview">
        </component>
        <component 
            class="parallel portrait" 
            :announcement="this.announcements[1]"
            :refreshPeriod="this.refreshPeriod"
            :isLandscape="false"
            :isParallel="true"
            :is="returnComponent(1)"
            :isPreview="isPreview">
        </component>
    </div>
</template>

<script>
    import BasicView from "../Templates/BasicView";
    import StudyDepartmentCallIn from "../Templates/StudyDepartmentCallIn";
    import EventPlanService from "../Templates/EventPlanService";
    import LessonPlanService from "../Templates/LessonPlanService";
    import FullScreenImageService from "../Templates/FullScreenImageService";
    import PublicTransportService from "../Templates/PublicTransportService";
    import FoodService from "../Templates/FoodService";

    export default {
        name: "TwoParallels",

        props: {
            announcements: Array,
            refreshPeriod: Number,
            isPreview: Boolean
        },

        components: {
            BasicView,
            StudyDepartmentCallIn,
            EventPlanService,
            LessonPlanService,
            FullScreenImageService,
            PublicTransportService,
            FoodService
        },

        methods: {
            returnComponent(num) {
                return this.announcements[num].serviceName !== null ? this.announcements[num].serviceName : "BasicView";
            },
        }
    }
</script>

<style scoped>
    .parallel {
        width: 50%;
        height: 100%;
    }
</style>
